import styled from 'styled-components';
import { TONE_SURFACES } from './toneSurfaces';

export type DeviceBadgeTone = 'recommended' | 'muted' | 'success' | 'warning';

const BADGE_TONE_CLASSES: Record<DeviceBadgeTone, string> = {
  recommended: 'bg-vantis-aquamarine/10 text-foreground',
  muted: 'bg-vantis-silver text-foreground',
  success: TONE_SURFACES.success,
  warning: 'bg-vantis-orange/50 text-foreground',
};

export const DeviceBadgeLabel = styled.span.attrs<{ $tone: DeviceBadgeTone }>(({ $tone }) => ({
  className: `rounded-md px-2 py-0.5 text-xs font-medium ${BADGE_TONE_CLASSES[$tone]}`,
}))<{ $tone: DeviceBadgeTone }>``;
